const { $ } = window;

jQuery.fn.addBack = jQuery.fn.andSelf;
(function($){
    $.fn.extend({
        donetyping: function(callback,timeout){
            timeout = timeout || 1e3; // 1 second default timeout
            var timeoutReference,
                doneTyping = function(el){
                    if (!timeoutReference) return;
                    timeoutReference = null;
                    callback.call(el);
                };
            return this.each(function(i,el){
                var $el = $(el);
                // Chrome Fix (Use keyup over keypress to detect backspace)
                // thank you @palerdot
                $el.is(':input') && $el.on('keyup keypress',function(e){
                    // This catches the backspace button in chrome, but also prevents
                    // the event from triggering too premptively. Without this line,
                    // using tab/shift+tab will make the focused element fire the callback.
                    if (e.type=='keyup' && e.keyCode!=8) return;

                    // Check if timeout has been set. If it has, "reset" the clock and
                    // start over again.
                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function(){
                        // if we made it here, our timeout has elapsed. Fire the
                        // callback
                        doneTyping(el);
                    }, timeout);
                }).on('blur',function(){
                    // If we can, fire the event since we're leaving the field
                    doneTyping(el);
                });
            });
        }
    });
})(jQuery);
window.addEventListener("load", function() {
    $('i[rel=tipsy], button[rel*=tipsy], a[rel*=tipsy], img[rel=tipsy], div[rel=tipsy], span[rel=tipsy], label[rel=tipsy]').tipsy({
        live: true,
        opacity: 1,
    });
    $('.contact-warning').tipsy({
        live: true,
        opacity: 1,
        gravity: 'e',
        html: 'true'
    });
    window.initDatePicker();
    $('.checkbox_list li').live('click', function() {
        $(this).find('input[type=radio]').prop('checked', true);
    });
    $("object[type='application/x-shockwave-flash']").each(function() {
        var param = 'name="wmode" value="transparent"';
        $(this).append('<param = ' + param + '/>');
    });
    $("table .accounts-info").each(function() {
        var $this = $(this);
        var newrows = [];
        $this.find("tr").each(function() {
            var i = 0;
            $(this).find("td").each(function() {
                i++;
                if (newrows[i] === undefined) {
                    newrows[i] = $("<tr></tr>");
                }
                newrows[i].append($(this));
            });
        });
        $this.find("tr").remove();
        $.each(newrows, function() {
            $this.append(this);
        });
    });
    if ($('.fixedElement').length) {
        $(window).scroll(function(e) {
            var $el = $('.fixedElement');
            var isPositionFixed = ($el.css('position') == 'fixed');
            if ($(this).scrollTop() > 150 && !isPositionFixed) {
                $('.fixedElement').css({'position': 'fixed', 'top': '0px', 'width': '265px'});
                $('.fixedElement').addClass('sticked');
            }
            if ($(this).scrollTop() < 150 && isPositionFixed) {
                $('.fixedElement').css({'position': 'static', 'top': '0px', 'width': '265px'});
                $('.fixedElement').removeClass('sticked');
            }
        });
    }

    //Init select2
    $('.select2').select2();
    
    //sidebars
    $('#dashboard-menu > li > ul.menu_level_1').each(function() {
        $ul = $(this).clone();
        $ul.addClass('cloneMenu');
        $(this).parent('li').append($ul);
    });
    $('#dashboard-menu > li.current_ancestor > ul.menu_level_1:not(.cloneMenu), #dashboard-menu > li.active > ul.menu_level_1:not(.cloneMenu)').show().css('visibility', 'visible');
    $('#dashboard-menu > li:not(.current_ancestor,.active)').bind('mouseover', openSubMenu);
    $('#dashboard-menu > li:not(.current_ancestor,.active)').bind('mouseout', closeSubMenu);
    $('#input_condition').on('change', function(e){
        if($(this).is(":checked")) {
            $('#btn_condition').removeClass('c-btn--disabled');
        } else {
            $('#btn_condition').addClass('c-btn--disabled');
        }
    })

    $('.js-toggle__ajax').on('change', function(e) {
        var element = $(this);

        if($(this).prop( "checked" ) == true){
            href = $(this).data('checked');
        }
        else{
            href = $(this).data('unchecked');
        }

        $.ajax({
            type: 'get',
            url: href,
            error: function(data) {
                if( $(element).prop( "checked" ) == true){
                    $(element).prop( "checked", false );
                }
                else{
                    $(element).prop( "checked", true );
                }
                notification.message = "Une erreur est survenue";
                notification.class = "success";
                YP.NotifManager().show(notification);
            },
            success: function(data) {
            }
        });
    });

    function openSubMenu() {
        $(this).find('ul.cloneMenu').show().css('visibility', 'visible');
    };

    function closeSubMenu() {
        $(this).find('ul.cloneMenu').hide().css('visibility', 'hidden');
    };
});

window.constructUrl = function constructUrl(path) {
    regExp = /^\/(\w+\_(dev|stage)\.php)/g;
    match = regExp.exec(location.pathname);
    if (match) {
        return location.origin + match[0] + '/' + path;
    } else {
        return location.origin + '/' + path;
    }
}
uniqid = (function() {
    var id = 1;
    return function() {
        return id++;
    };
})();

window.resizeIframe = function resizeIframe(iframe) {
    iframe.style.height = 0;
    iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
};
